import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaInstagram, FaTiktok, FaXTwitter } from 'react-icons/fa6';
import './Footer.css';
import logoFluencia from '../../images/logo.png';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (sectionId) => {
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const defaultOffset = 50;
        const sobreNosOffset = 110;
        const offset = sectionId === 'sobre-nos' ? sobreNosOffset : defaultOffset;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    handleNavClick('home');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo-section" style={{ cursor: 'pointer' }} onClick={handleLogoClick}>
            <img src={logoFluencia} alt="FluencIA Logo" className="footer-logo" />
            <span className="brand-name">FluencIA</span>
          </div>
          <div className="footer-social-section">
            <p>Nossas redes sociais</p>
            <div className="social-icons">
              <a href="https://www.instagram.com/inglesfluencia" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                <FaInstagram />
              </a>
              <a href="https://www.tiktok.com/@inglesfluencia" target="_blank" rel="noopener noreferrer" className="social-icon tiktok">
                <FaTiktok />
              </a>
              <a href="https://twitter.com/inglesfluencia" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                <FaXTwitter />
              </a>
            </div>
          </div>
          <div className="footer-contact-section">
            <p>Ficaremos felizes em ajudar</p>
            <a href="mailto:contato@inglesfluencia.com.br">contato@inglesfluencia.com.br</a>
            <Link to="/politica-de-privacidade" style={{ textDecoration: 'none', color: 'inherit' }}>
              <p>Política de Privacidade</p>
            </Link>
            <Link to="/termos-de-uso" style={{ textDecoration: 'none', color: 'inherit' }}>
              <p>Termos de Uso</p>
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Copyright © {new Date().getFullYear()} FluencIA</p>
      </div>
    </footer>
  );
};

export default Footer;
